import React from 'react'
import styled from 'styled-components'
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material'

import { Answer, Question } from '../../../types'
import theme from '../../../theme'

interface Props {
  question: Question
  onSelect: (answer: Answer, isConditionalRoute: boolean) => void
  selectedValue: string
  title: string
}


const Single: React.FC<Props> = ({ question, onSelect, selectedValue, title }) => {
  const { answers } = question
  const legendTitle = title

  const styles = {
    textAlign: 'left',
    alignItems: 'center',
    backgroundColor: 'white',
    border: 'solid',
    borderColor: theme.lightGrey,
    borderRadius: 0.5,
    borderWidth: 1,
    boxShadow: 'none',
    color: theme.blue,
    flexDirection: 'row',
    fontFamily: theme.primaryFont,
    height: '100%',
    lineHeight: '1.28',
    margin: 0,
    padding: '25px',
    textDecoration: 'none',
    textTransform: 'none',
    transition: 'all 0.3s ease',
    width: '100%',
    '&:hover': {
      boxShadow: '0 2px 10px 0 rgba(30, 30, 30, 0.4)',
      backgroundColor: theme.blue,
      borderColor: theme.blue,
      color: 'white',
      '& svg': {
        fill: 'white'
      }
    },
    '&:focus-within': {
      outline: '5px auto #005fcc',
      outlineOffset: '5px'
    },
    '&>span': {
      fontSize: '25px',
      fontFamily: theme.primaryFont
    }
  }

  return (
    <FormControl component="fieldset" sx={{
      marginTop: '60px',
      width: '100%',
      maxWidth: '604px'
    }}>
      <legend className="sr-only">{legendTitle}</legend>
      <RadioGroup name="customized-radios">
        {answers &&
          answers.map((answer: Answer, index) => {
            return (
              <ButtonContainer checked={selectedValue === answer.title} key={index}>
                <FormControlLabel
                  onClick={() => {
                    const isConditionalRoute = !!answer.conditionalRoute || !!answer.nextRouteId
                    onSelect(answer, isConditionalRoute)
                  }}
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      const isConditionalRoute = !!answer.conditionalRoute || !!answer.nextRouteId
                      onSelect(answer, isConditionalRoute)
                    }
                  }}
                  value={selectedValue === answer.title}
                  control={<Radio color="default" />}
                  label={answer.title}
                  sx={[styles]}
                  checked={selectedValue === answer.title}
                />
              </ButtonContainer>
            )
          })}
      </RadioGroup>
    </FormControl>
  )
}

const ButtonContainer = styled.div<{ checked: boolean }>`
  width: 100%;
  margin: 5px 0;

  ${({ checked, theme }) =>
    checked &&
    `
    > .MuiFormControlLabel-root {
      background-color: ${theme.blue};
      color: white;
      box-shadow: 0 2px 10px 0 rgba(30, 30, 30, 0.4);
      border-color: ${theme.blue};

      & svg {
        fill: white
      }
    }
  `};
`

export default Single
